export default "/assets/images/mila-halo.webp?f7844c41a817704c30a5a911d4ab5697";